import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

export interface IPostResponse {
  post: IPost;
}

export function usePostsApproveDraftAdminHttp() {
  return usePutHttp<null, IPostResponse>({
    path: "/admin/posts/:id/approve-draft",
  });
}
